<template>
  <div class="Login d-flex justify-content-center align-items-center min-vh-100">
    <div>
      <img
        class="hero"
        src="../assets/FinalLogo.png"
        style="flex: none; height: 250px; width: 250px;  margin-bottom: -60px;"
      />
      <h2 class="mb-3 px-1 py-1 mx-auto" style="color: #2596be">SOONFORWARD DEMO</h2>
      <!-- <h1 class="mb-3 px-1 py-1 mx-auto" style="color: white">SoonForward Demo</h1> -->
      <!-- <div class="mb-3 px-1 py-1 mx-auto d-inline-flex rounded-pill">
        <b-button
          class="mx-1 text-sm rounded-pill shadow-lg"
          variant="light"
          style="background: var(--bg-color);"
        >Login</b-button> -->
        <!-- <b-button
          class="mx-1 text-sm text-gray-300 rounded-pill border-0"
          to="/signup"
          variant="dark"
          style="background: transparent; color: gainsboro !important;"
        >Register</b-button> -->
      <!-- </div> -->
      <form @submit.prevent="authenticate"
        class="text-gray-100 mx-auto mb-5 px-5 py-3 rounded-lg shadow-lg"
        style="background: var(--bg-color); width: 400px;"
      >
        <b-alert :show="invalid" variant="warning" class="text-xs mb-4">
          There was an error with either the email or password. Please try again.
        </b-alert>
        <div class="floating-label-container position-relative mt-2">
          <b-icon-envelope
            class="text-gray-600 position-absolute"
            style="left: 0; top: 35%;"
          ></b-icon-envelope>
          <label class="col-form-label floating-label text-left" for="email">
            Email
          </label>
          <input
            id="email"
            class="form-control text-center pb-0"
            v-model="email"
            required
          />
        </div>
        <div class="floating-label-container position-relative">
          <b-icon-key
            class="text-gray-600 position-absolute"
            style="left: 0; top: 35%;"
          ></b-icon-key>
          <label class="col-form-label floating-label text-left" for="password">
            Password
          </label>
          <input
            id="password"
            class="form-control text-center pb-0"
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            required
          />
          <b-button
            type="button"
            class="text-gray-500 text-xs position-absolute border-0 py-0 px-1"
            variant="light"
            style="right: 0; top: 35%; background: var(--bg-color)"
            @click="showPassword = !showPassword"
          >
            <b-icon
              :icon="showPassword ? 'eye' : 'eye-slash'"
            ></b-icon>
          </b-button>
        </div>
        <b-button
          class="mt-4 mr-1 text-sm rounded-pill login-button"
          type="submit"
        >
          Login
        </b-button>
      </form>
    </div>
  </div>
</template>

<script>
import { login } from '../api/user';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      invalid: false,
    };
  },
  methods: {
    authenticate() {
      const data = { data: { email: this.email, password: this.password } };
      login(data).then((resp) => {
        console.log('Successfully POSTed');
        console.log(resp);
        this.$store.commit('authenticate', { jwt: resp.data });
        this.$router.push('/dash');
      }).catch((err) => {
        console.log(err);
        this.invalid = true;
      });
    },
  },
  mounted() {
    this.initFormlessFloatingLabels();
  },
};
</script>

<style scoped>
.form-control {
  background-color: transparent;
  border: none;
  border-bottom: 2px solid #cdcdcd;
  border-radius: 0;
}

.form-control:focus {
  background-color: transparent;
  box-shadow: none;
  border-color: var(--hover-color);
}

.floating-label-container{
  margin-top: 20px;
}

.floating-label {
  pointer-events: none;
  position: absolute;
  transform: translateX(-50%);
  z-index: 1;
  color: gray;
  transition: all 0.15s ease-out;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.floating-label.active {
  font-size: smaller;
  transform: translate(-50%, -63%);
}

.Login {
  background: radial-gradient(ellipse at top, var(--accent-color), var(--primary-color)),
  radial-gradient(ellipse at bottom, var(--hover-color), var(--secondary-color));
}

.login-button {
  background: var(--primary-color);
  border: none;
}

.login-button:hover {
  background: var(--secondary-color);
}

.signup-button {
  border: none;
  background: transparent;
  text-decoration: underline;
}
</style>
